<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <h3 class="title" v-if="form.type == 0">资产相关供应商列表</h3>
      <h3 class="title" v-else-if="form.type == 1">材料相关供应商列表</h3>
      <h3 class="title" v-else-if="form.type == 2">易耗品相关供应商列表</h3>
      <div class="r">
        <!--  v-if="backRole('SM_2')" -->
        <el-button type="primary" @click="AddBtnClick()" size="mini">新增供应商</el-button>
      </div>
    </div>
    <el-table :data="paginationData" style="width: 100%" v-loading="loading">
      <el-table-column type="index" label="序号" align="center" width="40">
      </el-table-column>
      <el-table-column prop="name" label="供应商" width="220" align="left">
      </el-table-column>
      <el-table-column prop="linkman" label="联系人" align="center">
      </el-table-column>
      <el-table-column prop="phone" label="联系电话" align="center">
      </el-table-column>
      <el-table-column prop="address" label="详细地址" width="220" align="left">
      </el-table-column>
      <el-table-column prop="remark" label="备注" align="left">
      </el-table-column>

      <el-table-column label="操作" align="right">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改供应商资料" placement="bottom">
            <i class="iconfont icon-xiugai meeting-btn-icon mbi-edit" @click="EditBtnClick(scope.row)"></i>
          </el-tooltip>

          <el-tooltip class="item" effect="dark" content="删除供应商" placement="bottom">
            <i class="iconfont icon-close meeting-btn-icon mbi-remove" @click="DeleteBtnClick(scope.row)"></i>
          </el-tooltip>
        </template>
      </el-table-column>

    </el-table>
    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length" @current-change="handleCurrentChange">
    </el-pagination>

    <!-- 添加供应商 -->
    <div class="pop-room" v-if="addStatus">
      <a href="javascript:;" @click="addStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="22">
          <el-form ref="form" :model="form" label-width="120px" class="form">
            <el-form-item label="供应商名称">
              <el-input size="small" v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="联系人">
              <el-input size="small" v-model="form.linkman"></el-input>
            </el-form-item>
            <el-form-item label="联系电话">
              <el-input size="small" v-model="form.phone"></el-input>
            </el-form-item>
            <el-form-item label="详细地址">
              <el-input size="small" v-model="form.address"></el-input>
            </el-form-item>
            <el-form-item label="备注">
              <el-input type="textarea" placeholder="请输入备注" :autosize="{ minRows: 3, maxRows: 6}" size="small" v-model="form.remark"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-button @click="SubmitBtnClick()" class="form-btn" type="success">确认提交</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";
  export default {
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        addStatus: false,
        // type: 0,
        editType: 1,
        form: {
          name: "",
          address: "",
          linkman: "",
          phone: "",
          remark: "",
          type: 0,
        },

        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
      }
    },
    created() {
      this.form.type = this.$route.params.type
    },
    mounted() {
      this.getLists()
    },
    components: {},
    methods: {
      // 编辑按钮点击
      EditBtnClick(row) {
        this.editType = 2
        this.addStatus = true
        // 单独赋值，防止数组映射
        this.form.supplierId = row.id
        this.form.name = row.name
        this.form.address = row.address
        this.form.linkman = row.linkman
        this.form.phone = row.phone
        this.form.remark = row.remark
      },
      // 新增按钮点击
      AddBtnClick() {
        this.editType = 1
        this.addStatus = true

        let _type = this.form.type
        this.form = {
          name: "",
          address: "",
          linkman: "",
          phone: "",
          remark: "",
          type: _type,
        }
      },
      // 提交
      SubmitBtnClick() {
        let _url = '/supplier/add'
        if (this.editType == 2) {
          _url = '/supplier/edit'
        }
        ajax.post(_url, this.form, (res) => {
          this.addStatus = false
          if (this.editType = 1) {
            this.$message.success("添加供应商成功")
          } else {
            this.$message.success("提交成功")
          }
          this.getLists()
        })
      },
      // 删除
      DeleteBtnClick(row) {
        this.$confirm('此操作将永久删除该供应商, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ajax.post('/supplier/del', {
            supplierId: row.id
          }, (res) => {
            this.$message.success("删除供应商成功")
            this.getLists()
          })
        }).catch(() => {});
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        console.log(this.filterName)
        if (this.filterName) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _new = this.listData[i]
            if (_new.name.indexOf(this.filterName) != -1) {
              this.filterData.push(_new)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this.currentPage)
      },
      // 获取列表
      getLists() {
        ajax.get('/supplier/list', {
          'type': this.form.type
        }, (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {
      '$route'() {
        this.form.type = this.$route.params.type
        this.getLists()
      }
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/asset/supplierList.vue